import { action } from 'vuex-class-component';
import { createModule } from '../preloader';
import { List } from '@/interfaces/list';
import { listService } from '@/services/restapi/list-service';
import { SearchItemTypes } from '@/util/enums/search-item-types';

export default class ListStore extends createModule('list') {
  private listsData = null as List[];
  private listsPromise = null as Promise<List[]>;

  get lists(): List[] {
    return this.listsData;
  }

  get isIdInList(): (id: number, type: SearchItemTypes) => boolean {
    return (id, type) => {
      for (const list of this.lists ?? []) {
        switch (type) {
          case SearchItemTypes.PROJECT:
            if (list.projects && list.projects.some(projectId => projectId === id)) return true;
            break;
          case SearchItemTypes.PROCUREMENT:
            if (list.procurements && list.procurements.some(procurementId => procurementId === id)) return true;
            break;
          case SearchItemTypes.COMPANY:
            if (list.companies && list.companies.some(companyId => companyId === id)) return true;
            break;
        }
      }
      return false;
    };
  }
  get listById(): (id: number) => List {
    return (id) => {
      if (this.lists === null) {
        return null;
      }
      for (const list of this.lists) {
        if (list.id == id) {
          return list;
        }
      }
      return null;
    };
  }

  get listsWithObjectId(): (id: number, type: SearchItemTypes) => List[] {
    return (id, type) => {
      return this.lists.filter((list) => {
        switch (type) {
          case SearchItemTypes.PROJECT:
            if (list.projects && list.projects.some(projectId => projectId === id)) return true;
            break;
          case SearchItemTypes.PROCUREMENT:
            if (list.procurements && list.procurements.some(procurementId => procurementId === id)) return true;
            break;
          case SearchItemTypes.COMPANY:
            if (list.companies && list.companies.some(companyId => companyId === id)) return true;
            break;
        }
        return false;
      });
    };
  }

  get listsLoaded(): boolean {
    return this.lists != null;
  }

  @action
  async putList(list: List): Promise<List> {
    const newList = await listService.putList(list);

    this.listsPromise = listService.getLists();
    this.listsData = await this.listsPromise;

    return newList;
  }

  @action
  async refetchLists() {
    this.listsPromise = listService.getLists();
    this.listsData = await this.listsPromise;

    return this.listsData;
  }

  @action
  async fetchLists() {
    if (this.listsData != null) {
      return this.listsData;
    }

    if (this.listsPromise != null) {
      return await this.listsPromise;
    }

    this.listsPromise = listService.getLists();
    this.listsData = await this.listsPromise;

    return this.listsData;
  }
}
